import { ColorV2, Text } from "@adoptaunabuelo/react-components";
import { Check } from "lucide-react";
import { useEffect } from "react";
import styled from "styled-components";

const SuccessCardViewContainer = styled.div`
	display: flex;
	height: var(--doc-height);
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;
const CheckIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 44px;
	width: 44px;
	border-radius: 44px;
	background-color: ${ColorV2.surface.primary};
    margin-bottom: 12px;
`;

const SuccessCardLayout = () => {
	useEffect(() => {
		window.top && window.top.postMessage("3DS-authentication-complete");
	});
	return (
		<SuccessCardViewContainer>
			<CheckIcon>
				<Check color={"white"} />
			</CheckIcon>
			<Text type="h3" weight="medium">
				Pago realizado con éxito
			</Text>
		</SuccessCardViewContainer>
	);
};
export default SuccessCardLayout;
